'use strict';

const ELLIPSIS_SYMBOL = '...';
export const saEllipsisContainer = [
  '$rootScope',
  '$timeout',

  function () {
    return {
      restrict: 'A',
      controller: [
        '$element',

        function ($element) {
          this.getHeight = function () {
            // TODO: this is such a performance hog
            // Kill me with fire, please
            return $element[0].offsetHeight;
          };
        }
      ]
    };
  }
];
export const saEllipsis = [
  '$rootScope',
  '$window',
  'throttle',

  function ($rootScope, $window, throttle) {
    var windowEl = angular.element($window);

    return {
      restrict: 'A',
      scope: {
        ngBind: '='
      },
      require: '^saEllipsisContainer',
      link: function ($scope, $element, $attrs, saEllipsisContainer) {
        var resizeHandler;

        function isOverflowed(maxHeight) {
          return maxHeight < $element[0].clientHeight;
        }

        function setEllipsis() {
          var maxHeight;
          var textLength;

          if (!$scope.ngBind) {
            $element.text();
            return;
          }

          maxHeight = saEllipsisContainer.getHeight();
          textLength = $scope.ngBind.length - 1 - ELLIPSIS_SYMBOL.length;

          $element.text($scope.ngBind);
          while(isOverflowed(maxHeight) && textLength > 0) {
            textLength--;
            $element.text($scope.ngBind.slice(0, textLength) + ELLIPSIS_SYMBOL);
          }
        }

        resizeHandler = throttle(setEllipsis, 60);

        $scope.$watch('ngBind', setEllipsis);
        // Disable because iOS Safari keeps laggin scrolling in conversations
        // windowEl.on('resize', resizeHandler);

        $scope.$on('$destroy', function () {
          windowEl.off('resize', resizeHandler);
        });
      }
    };
  }
];



// WEBPACK FOOTER //
// ./app/src/directives/ellipsis.js